<template>
  <div id="chartErosion" style="width: 100%;" v-if="this.erosion.length > 0"></div>

  <span v-else class="secondary&#45;&#45;text text&#45;&#45;lighten-1 textNoData">
      Sem dados para SIA.
  </span>

</template>

<script>
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';
import { mapGetters } from 'vuex';
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: 'CardErosionChart',

  mounted() {
    setTimeout(() => {
      if (this.erosion.length > 0) {
        this.createChartErosion();
      }
    }, 100);
    window.addEventListener('chartErosion', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('chartErosion', this.handleResize);
  },

  data: () => ({
    dataErosion: {
      susceptibilidade: null,
      vulnerabilidade: null,
      erodibilidade: null,
      erosionChart: null
    },
  }),

  computed: {
    ...mapGetters(['erosion']),
  },
  methods: {

    handleResize() {
      this.erosionChart.reflow();
    },
    createChartErosion() {
      if (this.erosion && this.erosion.length > 0
      && typeof this.erosion[0].regiao != 'undefined'
      && this.erosion[0].regiao == 'PR') {
          this.erosion.forEach((el) => {
          if (el.palavrachave == 'suscetibilidade') {
            this.dataErosion.susceptibilidade = el.percs;
          }

          if (el.palavrachave == 'vulnerabilidade') {
            this.dataErosion.vulnerabilidade = el.percs;
          }

          if (el.palavrachave == 'erodibilidade') {
            this.dataErosion.erodibilidade = el.percs;
          }
        });
      } else if (this.erosion.length > 0) {
        this.dataErosion = this.erosion[0];
      }

      Highcharts.setOptions({
        lang: {
          decimalPoint: ',',
          thousandsSep: '.'
        }
      });
      this.erosionChart = Highcharts.chart('chartErosion', {
        chart: {
          type: 'bar',
          height: 143,
          backgroundColor: 'transparent',
          marginTop: 8,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: { enabled: false },
        exporting: { enabled: false },

        xAxis: {
          labels: {
            enabled: false,
          },
          visible: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          labels: {
            format: '{value}%',
            style: {
              color: 'rgba(135, 146, 213, 0.5)',
            },
          },

          gridLineDashStyle: 'Dash',
          gridLineColor: 'rgba(135, 146, 213, 0.5)',

          plotLines: [
            {
              width: 2,
              value: 2.5,
              color: 'transparent',
              zIndex: 2,
              label: {
                text: 'Erodibilidade',
                rotation: 0,
                verticalAlign: 'top',
                textAlign: 'left',
                y: 5,
                x: -4,

                style: {
                  color: '#FFFFFF',
                  fontSize: '10',
                },
              },
            },

            {
              width: 2,

              value: 2.5,
              color: 'transparent',
              zIndex: 3,
              label: {
                text: 'Susceptibilidade',
                rotation: 0,
                verticalAlign: 'top',
                textAlign: 'left',
                y: 38,
                x: -4,

                style: {
                  color: '#FFFFFF',
                  fontSize: '10',
                },
              },
            },

            {
              width: 2,
              value: 2.5,
              color: 'transparent',
              zIndex: 4,
              label: {
                text: 'Vulnerabilidade',
                rotation: 0,
                verticalAlign: 'top',
                textAlign: 'left',
                y: 70,
                x: -4,

                style: {
                  color: '#FFFFFF',
                  fontSize: '10',
                },
              },
            },
          ],
        },
        legend: {
          reversed: true,
          enabled: false,
        },

        plotOptions: {
          series: {
            stacking: 'percent',
            groupPadding: 0.2,
            borderRadius: 0,

            dataLabels: {
              enabled: false,
            },
            borderWidth: 0,
          },
        },

        tooltip: {
          backgroundColor: '#212A35',

          borderRadius: 5,
          headerFormat: `
          <table>`,
          pointFormat:
            '<tr><td style="color:{series.color};padding:0"><div style="width: 16.13px; height: 4.03px; background-color:{series.color}"></div> </td>' +
            '<td style="color: #FFFFFF;"> <span>{series.name}</span></td><td style="color: #FFFFFF;"><span style="text-align: right">' +
              `{point.y:.1f}%</span></td>`,
          footerFormat: `</tr></table>`,
          shared: true,
          useHTML: true,
        },

        series: [
          //erodibilidade
          {
            name: 'Área Urbana',
            data: [this.dataErosion.erodibilidade['Área Urbana']],
            color: '#8792D5',
          },
          {
            name: 'Muito Baixa',
            data: [this.dataErosion.erodibilidade['Muito baixa']],
            color: '#BDB053',
          },

          {
            name: 'Baixa',
            data: [this.dataErosion.erodibilidade['Baixa']],
            color: '#9A853E',
          },

          {
            name: 'Moderada',
            data: [this.dataErosion.erodibilidade['Moderada']],
            color: '#AC8641',
          },
          {
            name: 'Média',
            data: [this.dataErosion.erodibilidade['Média']],
            color: '#AC8641',
          },
          {
            name: 'Alta',
            data: [this.dataErosion.erodibilidade.Alta],
            color: '#613D1E',
          },
          {
            name: 'Muito Alta',
            data: [this.dataErosion.erodibilidade['Muito alta']],
            color: '#591602',
          },
          {
            name: 'Afloramento de Rochas',
            data: [this.dataErosion.erodibilidade['Afloramento de Rochas']],
            color: '#7C4EA6',
          },
          {
            name: "Corpos d'água",
            data: [
              this.dataErosion.erodibilidade['Área Urbana e Corpos Hídricos'],
            ],
            color: '#56CCF2',
          },

          {
            name: 'Outros',
            data: [this.dataErosion.erodibilidade['Outros']],
            color: '#E0E0E0',
          },

          //susceptibilidade
          {
            name: 'Área Urbana',
            data: [null, this.dataErosion.susceptibilidade['Área Urbana']],
            color: '#8792D5',
          },
          {
            name: 'Muito Baixa',
            data: [null, this.dataErosion.susceptibilidade['Muito baixa']],
            color: '#BDB053',
          },

          {
            name: 'Baixa',
            data: [null, this.dataErosion.susceptibilidade['Baixa']],
            color: '#9A853E',
          },

          {
            name: 'Moderada',
            data: [null, this.dataErosion.susceptibilidade['Moderada']],
            color: '#AC8641',
          },
          {
            name: 'Média',
            data: [null, this.dataErosion.susceptibilidade['Média']],
            color: '#AC8641',
          },
          {
            name: 'Alta',
            data: [null, this.dataErosion.susceptibilidade.Alta],
            color: '#613D1E',
          },
          {
            name: 'Muito Alta',
            data: [null, this.dataErosion.susceptibilidade['Muito alta']],
            color: '#591602',
          },
          {
            name: 'Afloramento de Rochas',
            data: [
              null,
              this.dataErosion.susceptibilidade['Afloramento de Rochas'],
            ],
            color: '#7C4EA6',
          },
          {
            name: "Corpos d'água",
            data: [
              null,
              this.dataErosion.susceptibilidade[
              'Área Urbana e Corpos Hídricos'
              ],
            ],
            color: '#56CCF2',
          },

          {
            name: 'Outros',
            data: [null, this.dataErosion.susceptibilidade['Outros']],
            color: '#E0E0E0',
          },
          //  vulnerabilidade
          {
            name: 'Área Urbana',
            data: [null, null, this.dataErosion.vulnerabilidade['Área Urbana']],
            color: '#8792D5',
          },
          {
            name: 'Muito Baixa',
            data: [null, null, this.dataErosion.vulnerabilidade['Muito baixa']],
            color: '#BDB053',
          },

          {
            name: 'Baixa',
            data: [null, null, this.dataErosion.vulnerabilidade['Baixa']],
            color: '#9A853E',
          },

          {
            name: 'Moderada',
            data: [null, null, this.dataErosion.vulnerabilidade['Moderada']],
            color: '#AC8641',
          },
          {
            name: 'Média',
            data: [null, null, this.dataErosion.vulnerabilidade['Média']],
            color: '#AC8641',
          },
          {
            name: 'Alta',
            data: [null, null, this.dataErosion.vulnerabilidade.Alta],
            color: '#613D1E',
          },
          {
            name: 'Muito Alta',
            data: [null, null, this.dataErosion.vulnerabilidade['Muito alta']],
            color: '#591602',
          },
          {
            name: 'Afloramento de Rochas',
            data: [
              null,
              null,
              this.dataErosion.vulnerabilidade['Afloramento de Rochas'],
            ],
            color: '#7C4EA6',
          },
          {
            name: "Corpos d'água",
            data: [
              null,
              null,
              this.dataErosion.vulnerabilidade['Área Urbana e Corpos Hídricos'],
            ],
            color: '#56CCF2',
          },

          {
            name: 'Outros',
            data: [null, null, this.dataErosion.vulnerabilidade['Outros']],
            color: '#E0E0E0',
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
.textNoData {
  color: #95A1EC;
  font-size: 14px;
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 20px;
}
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}

.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}

.textBovines {
  font-family: 'Roboto';
  font-style: Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
}

.textTotalBovines {
  font-family: 'Roboto';
  font-style: Bold;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #ffffff;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
